import React from "react";
import classes from "./LearnerClickComponent.module.css";
import Plot from "react-plotly.js";

interface LearClickComponentProps {
  path_name: string;
  index: number;
  clicks: number;
  max_interaction: number;
}

const cleanPathName = (path: string) => {
  return path.split(" ")[3]
}

function LearClickComponent({ path_name, index, clicks ,max_interaction }: LearClickComponentProps) {
  const clean_path_name = cleanPathName(path_name);
  const getColorByIndex = (index: number) => {
    switch (index % 3) {
      case 0:
        return "#30c1d9";
      case 1:
        return "#006e87";
      case 2:
        return "#24304f";
      default:
        break;
    }
  };
  
  const layout = {
    height: 43,
    margin: {
      l: 0,
      r: 0,
      t: 0,
      b: 0,
    },
    xaxis: {
      range: [0, max_interaction + 10],
      showgrid: false,
      zeroline: false,
      showticklabels: false,
    },
    yaxis: {
      showgrid: false,
      zeroline: false,
      showticklabels: false,
    },
    bargap: 0,
    paper_bgcolor: "rgba(0,0,0,0)",
    plot_bgcolor: "#F2F2F6",
    barcornerradius: 5,
    annotations: [
      {
        x: 95,
        y: 0,
        text: "",
        showarrow: false,
      },
    ],
  };

  const config = {
    displayModeBar: false,
    responsive: true,
    staticPlot: true,
  };

  return (
    <div className={classes.metricsRow}>
      <div className={classes.metricsLeft}>
        <div
          style={{ color: getColorByIndex(index) }}
          className={classes.metricNumber}
        >
          {clicks}
        </div>
        <div className={classes.metricLabel1}>{clean_path_name}</div>
      </div>
      <div className={classes.verticalLine}></div>
      <div className={classes.metricsRight}>
        <Plot
          data={[
            {
              x: [clicks],
              y: [""],
              type: "bar" as const,
              orientation: "h" as const,
              name: "Completed",
              marker: {
                color: getColorByIndex(index),
              },
              hoverinfo: "skip" as const,
              showlegend: false,
            }
          ]}
          layout={layout}
          config={config}
          className={classes.plotlyChart}
        />
        <div className={classes.metricLabel2}>
          {`${clicks || "0"} clicks`}
        </div>
      </div>
    </div>
  );
}

export default LearClickComponent;
